import * as Yup from 'yup';

export type TFormValues = {
  email: string;
  password: string;
};

export const initialValues: TFormValues = { email: '', password: '' };

export const validationSchema = Yup.object().shape({
  email: Yup.string().required('validation.required').email('validation.email'),
  password: Yup.string().required('validation.required'),
});
